<template>
    <div class="admin-login">
        <div class="login-card">
            <div class="brand">
                <div class="brand-mark">信</div>
                <div class="brand-text">
                    <h1>信 箱 后 台</h1>
                    <p>EduAim · 页面发布与维护</p>
                </div>
            </div>

            <div class="field">
                <label>管理密码</label>
                <input
                    ref="pwd"
                    v-model="password"
                    type="password"
                    placeholder="请输入管理密码"
                    @keyup.enter.native="doLogin"
                />
            </div>

            <div class="tip" v-if="tip">{{ tip }}</div>

            <button class="btn-login" :disabled="loading" @click="doLogin">
                {{ loading ? '正在登录…' : '登 录' }}
            </button>

            <div class="hint">
                密码在服务端 <code>appsettings.json</code> 的 <code>Admin:Password</code> 中配置（默认 admin123456）
            </div>
        </div>
    </div>
</template>

<script>
import { adminApi, setToken, getToken, API_BASE } from './api';

export default {
    name: 'AdminLogin',
    data() {
        return {
            password: '',
            loading: false,
            tip: ''
        };
    },
    created() {
        // 已登录直接进列表
        if (getToken()) {
            this.$router.replace('/admin/pages');
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$refs.pwd) this.$refs.pwd.focus();
        });
    },
    methods: {
        doLogin() {
            if (this.loading) return;
            if (!this.password) {
                this.tip = '请先输入管理密码';
                return;
            }
            this.loading = true;
            this.tip = '';
            adminApi
                .login(this.password)
                .then(data => {
                    setToken(data && data.token);
                    this.$router.replace('/admin/pages');
                })
                .catch(err => {
                    this.tip = err.message + '（接口：' + API_BASE + '）';
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>

<style lang="less" scoped>
.admin-login {
    min-height: 100vh;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    background: radial-gradient(circle at 50% 0%, #fdf3e7 0%, #f4e6d6 55%, #ecdcC8 100%);
}

.login-card {
    width: 100%;
    max-width: 420px;
    box-sizing: border-box;
    background: #fff;
    border: 1px solid #e6d6c2;
    border-radius: 14px;
    box-shadow: 0 18px 46px rgba(120, 86, 44, 0.16);
    padding: 36px 34px 26px;
}

.brand {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 30px;
}
.brand-mark {
    width: 48px;
    height: 48px;
    flex: none;
    border-radius: 12px;
    background: linear-gradient(140deg, #cf1f3d, #a3122e);
    color: #fff;
    font-size: 24px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 6px 16px rgba(163, 18, 46, 0.32);
}
.brand-text {
    h1 {
        margin: 0;
        font-size: 19px;
        font-weight: 700;
        color: #4a3629;
        letter-spacing: 3px;
    }
    p {
        margin: 5px 0 0;
        font-size: 12px;
        color: #a08a76;
        letter-spacing: 0.5px;
    }
}

.field {
    margin-bottom: 16px;
    label {
        display: block;
        margin-bottom: 8px;
        font-size: 13px;
        color: #7a6553;
    }
    input {
        width: 100%;
        box-sizing: border-box;
        height: 42px;
        padding: 0 12px;
        font-size: 14px;
        color: #3f3126;
        background: #fdfaf6;
        border: 1px solid #e0cdb6;
        border-radius: 8px;
        outline: none;
        transition: border-color 0.2s, box-shadow 0.2s;
        &:focus {
            border-color: #cf1f3d;
            box-shadow: 0 0 0 3px rgba(207, 31, 61, 0.1);
            background: #fff;
        }
    }
}

.tip {
    margin: 0 0 12px;
    padding: 9px 12px;
    font-size: 12.5px;
    line-height: 1.6;
    color: #a3122e;
    background: #fdeef1;
    border: 1px solid #f4ccd5;
    border-radius: 8px;
    word-break: break-all;
}

.btn-login {
    width: 100%;
    height: 44px;
    margin-top: 6px;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 4px;
    color: #fff;
    background: linear-gradient(140deg, #cf1f3d, #a3122e);
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: opacity 0.2s, transform 0.1s;
    &:hover:not(:disabled) {
        opacity: 0.92;
    }
    &:active:not(:disabled) {
        transform: translateY(1px);
    }
    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

.hint {
    margin-top: 18px;
    font-size: 11.5px;
    line-height: 1.7;
    color: #a89383;
    code {
        padding: 1px 4px;
        font-size: 11px;
        color: #8a6a52;
        background: #f6efe6;
        border-radius: 4px;
    }
}
</style>
